import {
  resourcesLossOfControl,
  resourcesWorkLifeBalance,
} from "@/features/mentor/data/resources";
import { Book, Library } from "lucide-react";

import { SessionAnalysis } from "@/types/supabase";

interface ResourcesSharedProps {
  analysis: SessionAnalysis;
}

export const ResourcesShared = ({ analysis }: ResourcesSharedProps) => {
  const resources =
    analysis?.content?.stressor_confidence?.label === "loss_of_control"
      ? resourcesLossOfControl
      : analysis?.content?.stressor_confidence?.label === "work_life_balance"
        ? resourcesWorkLifeBalance
        : [];
  return (
    <section className="rounded-xl bg-white p-6 shadow-sm">
      <h2 className="mb-6 flex items-center text-xl font-semibold">
        <Library className="mr-2 size-5 text-green-600" />
        Resources Shared
      </h2>
      <div>
        {resources.length > 0 ? (
          <>
            {resources.map((resource, index) => (
              <div
                key={`resource-${index}`}
                className="flex items-start gap-4 rounded-lg bg-gray-50 p-4"
              >
                <Book className="mt-1 size-5 text-green-600" />
                <div>
                  <h3 className="font-medium">
                    <a
                      href={resource.link || "#"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600 hover:underline"
                    >
                      <strong>{resource.type}:</strong> {resource.name}
                    </a>
                  </h3>
                  {resource.description && (
                    <p className="text-sm text-gray-600">
                      {resource.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : (
          <p className={`rounded-lg bg-gray-50 p-4`}>
            No resources were shared...
          </p>
        )}
      </div>
    </section>
  );
};
